// extracted by mini-css-extract-plugin
export default {"header":"Header_header__VlSWf","logo":"Header_logo__-Lkdn","menuBtn":"Header_menuBtn__ZmRFA"};